module.exports = require("././dist/angular-table.js");


/*****************
 ** WEBPACK FOOTER
 ** at-table (bower component)
 ** module id = 376
 ** module chunks = 1
 **/